// assets/js/components/revenue-calculator/steps/step-6c.js
var ui = require("../ui");
var data = require("../data");

var ADMIN_FIELDS = [
    ["adminManual", _t("Manual booking management")],
    ["adminFollowup", _t("Client follow-up and reminders")],
    ["adminMarketing", _t("Marketing and client communication")],
    ["adminReporting", _t("Reporting and admin")],
    ["adminForms", _t("Forms, consultation prep or intake admin")]
];

function render(state) {
    var d = state.d;
    var html = ui.stepLabel(_t("Advanced step 3 of 3")) + ui.h2(_t("How much admin time does your team spend each week?")) +
        ui.sub(_t("This helps us estimate time that could be saved and redirected into revenue-generating work."));

    ADMIN_FIELDS.forEach(function (pair) {
        html += ui.field({
            id: "rc-" + pair[0], label: pair[1], required: true,
            inner: ui.select({ id: "rc-" + pair[0], value: d[pair[0]], options: data.options(data.HOURS_OPTS) })
        });
    });
    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue to results") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    ADMIN_FIELDS.forEach(function (pair) {
        container.querySelector("#rc-" + pair[0]).addEventListener("change", function (e) { actions.setField(pair[0], e.target.value); });
    });
    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        // Target the actually-missing field (not always ADMIN_FIELDS[0]) so the
        // error scrolls/focuses to whichever hour dropdown the user skipped.
        var missing = ADMIN_FIELDS.filter(function (pair) { return !d[pair[0]]; });
        if (missing.length) {
            actions.showError("rc-" + missing[0][0], _t("Please complete all time fields."));
            return;
        }
        state.step = 7;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
